export const ACTIVATE_ADVERTISEMENT_START =
  'ACTIVATE_ADVERTISEMENT_START';
export const ACTIVATE_ADVERTISEMENT_SUCCESS =
  'ACTIVATE_ADVERTISEMENT_SUCCESS';
export const ACTIVATE_ADVERTISEMENT_ERROR =
  'ACTIVATE_ADVERTISEMENT_ERROR';
